import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Marker } from "react-leaflet";
import { Navigation } from "lucide-react";
import { WomaMap } from "./WomaMap";
import { roleIcon } from "./roleMarkers";
import { useGeolocation } from "@/hooks/useGeolocation";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Client : sa position + livreurs/chauffeurs en ligne autour de lui
export const ClientMapPanel = () => {
  const navigate = useNavigate();
  const { position, status, request } = useGeolocation();
  const [couriers, setCouriers] = useState([]);

  useEffect(() => {
    const load = () => axios.get(`${API}/gps/active-couriers`).then((r) => setCouriers(r.data || [])).catch(() => {});
    load();
    const t = setInterval(() => !document.hidden && load(), 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (position) axios.put(`${API}/users/me/location`, { latitude: position.lat, longitude: position.lng, role: "client" }).catch(() => {});
  }, [position?.lat, position?.lng]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="space-y-3" data-testid="client-map-panel">
      <div className="flex items-end justify-between">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.3em] text-[#D4AF37]">Autour de moi</p>
          <p className="text-sm text-slate-300 mt-1" data-testid="client-map-couriers-count">
            {couriers.length} livreur{couriers.length > 1 ? "s" : ""} / chauffeur{couriers.length > 1 ? "s" : ""} en ligne
          </p>
        </div>
        <button
          type="button"
          disabled={!position}
          onClick={() => navigate(`/orders/new?pickup_lat=${position.lat}&pickup_lng=${position.lng}`)}
          className="rounded-full bg-[#D4AF37] disabled:opacity-40 text-[#0F172A] px-4 py-2 text-[11px] font-black uppercase tracking-widest flex items-center gap-2 active:scale-95 transition-transform"
          data-testid="client-map-order-here-btn"
        >
          <Navigation size={14} /> Commander d'ici
        </button>
      </div>
      <WomaMap self={position} role="client" status={status} onRequest={request} testId="client-map">
        {couriers.filter((c) => c.latitude && c.longitude).map((c) => (
          <Marker key={c.courier_id} position={[c.latitude, c.longitude]} icon={roleIcon(c.driver_type === "taxi" ? "taxi" : "courier", { size: 30 })} />
        ))}
      </WomaMap>
    </section>
  );
};
